import { Logo } from '@rr/ui'

export function Footer() {
  return (
    <footer className="border-t border-border">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[13.5px] text-muted-foreground">
        <div className="flex items-center gap-2 text-primary">
          <Logo tone="current" size={20} />
          <span className="font-semibold text-foreground tracking-tight text-[14.5px]">
            Route and Route
          </span>
        </div>
        <p>© {new Date().getFullYear()} Route and Route. Logistika toparlary üçin döredildi.</p>
        <p className="font-mono tracking-tight">routenroute.com</p>
      </div>
    </footer>
  )
}
